/**
 * Added to entites affected by hiding/showing doors (fronts and children to fronts).
 */
class ToggleDoorsComponent {
    constructor(doorsHidden) {
        this.typeId = ToggleDoorsComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
        this.doorsHidden = doorsHidden;
    }
    eq(other) {
        return this.doorsHidden === other.doorsHidden;
    }
}
ToggleDoorsComponent.id = 2068;
export default ToggleDoorsComponent;
//# sourceMappingURL=ToggleDoorsComponent.js.map